import styled from "styled-components";
import worldcupImg2 from "../../../../assets/images/worldcup_img2.png";

const TravelPaymentGatewayStyleWrapper = styled.div`
 min-height: 70vh;

 .worldcup_payment_bg_img {
  background-image: url(${worldcupImg2});
  height: 800px;

  h2 {
    color: #ffffff;
  }
 }
 *{
    text-align: initial;
  }

  h2{
      font-size: 24px;
      text-align: initial;
      color: #4c565c;
  }
  @media only screen and (max-width: 576px) {
    .ar{
       h2{
            font-size: 1rem;
        }
    }
  }
`;
export default TravelPaymentGatewayStyleWrapper;